import { Controller } from "@hotwired/stimulus";

// The "Magia reversa" card: shows how the spell's page will read for the chosen base, and
// keeps the spell private while its own base is, which the server enforces anyway.
export default class extends Controller<HTMLElement> {
	static targets = ["select", "badge", "text", "lock", "lockName"];
	static values = { intro: String, none: String };

	declare readonly selectTarget: HTMLSelectElement;
	declare readonly badgeTarget: HTMLElement;
	declare readonly textTarget: HTMLElement;
	declare readonly lockTarget: HTMLElement;
	declare readonly lockNameTarget: HTMLElement;
	declare readonly introValue: string;
	declare readonly noneValue: string;

	connect() {
		this.update();
	}

	update() {
		const option = this.selectTarget.selectedOptions[0];
		const name = option?.value ? option.dataset.name : undefined;

		this.badgeTarget.hidden = !name;
		this.textTarget.textContent = name ? this.introValue.replace("%{name}", name) : this.noneValue;
		const locked = option?.dataset.ownPrivate === "true";
		this.lockTarget.hidden = !locked;
		this.lockNameTarget.textContent = name ?? "";

		const sharing = this.element.closest("form")?.querySelector<HTMLSelectElement>("select[name='spell[sharing]']");
		if (!sharing) return;
		if (locked) sharing.value = "not_shared";
		for (const choice of sharing.options) choice.disabled = locked && choice.value !== "not_shared";
	}
}
